<template>
  <div>
    <tabs v-model="activeTab" @change="onChangeTab" color="#fc9153" title-active-color="#fc9153" swipeable sticky >
      <tab v-for="tabItem in tabList" :key="tabItem.list_type" :name="tabItem.list_type">
        <div slot="title">
          <div class="title-slot">
            <span>{{tabItem.name}}</span>
          </div>
        </div>
      </tab>
      <div class="content-list">
<!--        <MixItemFeedGoods :listType="activeTab" v-if="listStyle(activeTab) === 'two-col'"></MixItemFeedGoods>-->
<!--        <MixItemFeed :listType="activeTab" v-else></MixItemFeed>-->
        <GeneralDisplayBoxFeed :listType="activeTab"></GeneralDisplayBoxFeed>
      </div>
    </tabs>
  </div>
</template>

<script>

  import {Tab, Tabs} from "vant"

  import MixItemFeedGoods from "../ugc_item/MixItemFeedGoods";
  import MixItemFeed from "../ugc_item/MixItemFeed";
  import GeneralDisplayBox from "../ugc_item/GeneralDisplayBox";
  import GeneralDisplayBoxFeed from "../ugc_item/GeneralDisplayBoxFeed";
  export default {
    name: "TabList",
    components: {GeneralDisplayBoxFeed, GeneralDisplayBox, MixItemFeed, MixItemFeedGoods, Tabs, Tab},
    props: {
      dataList: {},
      config: {},
      initialActiveTab: {},
    },
    data() {
      return {
        activeTab: "",
        tabList: [],
        tabMap: {},
      }
    },

    mounted() {
      this.initTabList()
    },

    methods: {
      initTabList() {
        if (this.config && this.config.active_list_type) {
          this.activeTab = this.config.active_list_type
        }
        if (this.initialActiveTab) {
          this.activeTab = this.initialActiveTab
        }

        this.tabList = this.dataList
        for (let i = 0; i < this.tabList.length; i ++) {
          this.tabMap[this.tabList[i].list_type] = this.tabList[i]
        }
      },

      onChangeTab() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        let queries = {
          "list_type": this.activeTab
        }
        this.$router.push({query: queries})
      },

      listStyle(listType) {
        if (this.tabMap[listType]) {
          return this.tabMap[listType].list_style || ''
        }
        return ''
      }
    },

    watch: {
      dataList() {
        this.initTabList()
      }
    },

  }
</script>

<style lang="scss" scoped>

  .content-list {
    background: #fafafa;
    margin-top: 5px;
    min-height: 80vh;

    .content-title {
      padding: 8px 13px;
      border-left: solid 3px blue;
    }
  }

</style>
